import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  if ($('body').is('#admin-templates')) {
    $('[data-admin-templates-sortable]').each(function () {
      const $tbody = $(this);
      const kind = $tbody.data('kind');

      $tbody.sortable({
        items: 'tr',
        cursor: 'move',
        tolerance: 'pointer',
        stop: () => {
          const order = $tbody
            .find('tr')
            .map(function () {
              return $(this).data('template-id');
            })
            .get();

          $.ajax({
            url: '/u/admin/templates/sort',
            method: 'PATCH',
            data: { order, kind },
          });
        },
      });
    });
  }
});
